<template>
    <div class="main">
        <c-panel title="PRESENÇA PARA A MERENDA" titleIcon="fas fa-utensils">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Consolida a presença lançada no diário para dimensionar as refeições do dia."
                description="Turma sem chamada lançada não aparece — ausência de lançamento não é o mesmo que ausência de alunos."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="recarregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="14" class="u-text-right u-mt-25">
                        <el-radio-group v-model="aba" size="small" @change="recarregar">
                            <el-radio-button label="diario">Diário</el-radio-button>
                            <el-radio-button label="periodo">Período</el-radio-button>
                        </el-radio-group>
                    </el-col>
                </el-row>
            </el-form>

            <!-- ==================== DIÁRIO ==================== -->
            <div v-if="aba === 'diario'">
                <el-form label-position="top" @submit.native.prevent>
                    <el-row :gutter="10" class="u-mb-15">
                        <el-col :xs="12" :sm="5">
                            <el-form-item label="Data" class="u-mb-0">
                                <el-date-picker v-model="data" type="date" format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd" style="width: 100%;" @change="carregarDiario"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="19" class="u-text-right u-mt-25">
                            <el-button v-if="podeEscrever" type="primary" size="small" icon="el-icon-refresh" @click="consolidar">
                                CONSOLIDAR O DIA
                            </el-button>
                            <el-button class="u-ml-10" size="small" icon="el-icon-printer" :disabled="!diario || !diario.consolidado" @click="imprimir">IMPRIMIR</el-button>
                        </el-col>
                    </el-row>
                </el-form>

                <div v-if="diario && diario.consolidado">
                    <el-row :gutter="10" class="u-mb-20">
                        <el-col :xs="12" :sm="6"><div class="kpi"><span class="n">{{ diario.total_presentes }}</span><span class="r">Presentes</span></div></el-col>
                        <el-col :xs="12" :sm="6"><div class="kpi kpi-refeicao"><span class="n">{{ diario.total_refeicoes_previstas }}</span><span class="r">Refeições previstas</span></div></el-col>
                        <el-col :xs="24" :sm="12">
                            <div class="kpi">
                                <span class="r">Consolidação de {{ dataBr(diario.data) }} — {{ diario.instituicao }}</span>
                            </div>
                        </el-col>
                    </el-row>

                    <h4 class="u-mb-10">Consolidado por turno</h4>
                    <div class="container-table u-mb-20">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Turno</th>
                                    <th style="width: 110px;" class="u-text-center">Matriculados</th>
                                    <th style="width: 100px;" class="u-text-center">Presentes</th>
                                    <th style="width: 90px;" class="u-text-center">%</th>
                                    <th style="width: 120px;" class="u-text-center">Previstas</th>
                                    <th style="width: 200px;" class="u-text-center">Refeições servidas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="t in diario.por_turno" :key="t.id">
                                    <td>{{ rotuloTurno(t.turno) }}</td>
                                    <td class="u-text-center">{{ t.qtd_matriculados }}</td>
                                    <td class="u-text-center">{{ t.qtd_presentes }}</td>
                                    <td class="u-text-center">{{ t.percentual_presenca !== null ? t.percentual_presenca + '%' : '—' }}</td>
                                    <td class="u-text-center">{{ t.qtd_refeicoes_previstas }}</td>
                                    <td class="u-text-center">
                                        <el-input-number v-model="servidas[t.id]" :min="0" size="mini"
                                            controls-position="right" style="width: 110px;"></el-input-number>
                                        <el-button v-if="podeEscrever" size="mini" type="text" @click="informarServidas(t)">GRAVAR</el-button>
                                        <div v-if="t.saldo_refeicoes !== null">
                                            <el-tag size="mini" :type="t.saldo_refeicoes < 0 ? 'danger' : 'success'">
                                                saldo {{ t.saldo_refeicoes > 0 ? '+' : '' }}{{ t.saldo_refeicoes }}
                                            </el-tag>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="diario.por_turno.length === 0"><td colspan="6" class="u-text-center">Sem consolidado por turno.</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <small class="u-text-muted u-mb-20" style="display: block;">
                        As refeições servidas são informadas por TURNO — a cozinha conta o que serviu no
                        refeitório, não por turma.
                    </small>

                    <h4 class="u-mb-10">Por turma</h4>
                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Turma</th>
                                    <th style="width: 110px;">Turno</th>
                                    <th style="width: 110px;" class="u-text-center">Matriculados</th>
                                    <th style="width: 100px;" class="u-text-center">Presentes</th>
                                    <th style="width: 90px;" class="u-text-center">%</th>
                                    <th style="width: 120px;" class="u-text-center">Previstas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="t in diario.turmas" :key="t.id">
                                    <td>{{ t.turma_nome || '—' }}</td>
                                    <td>{{ rotuloTurno(t.turno) }}</td>
                                    <td class="u-text-center">{{ t.qtd_matriculados }}</td>
                                    <td class="u-text-center">{{ t.qtd_presentes }}</td>
                                    <td class="u-text-center">{{ t.percentual_presenca !== null ? t.percentual_presenca + '%' : '—' }}</td>
                                    <td class="u-text-center">{{ t.qtd_refeicoes_previstas }}</td>
                                </tr>
                                <tr v-if="diario.turmas.length === 0"><td colspan="6" class="u-text-center">Nenhuma turma consolidada.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <el-alert v-else-if="diario" type="info" :closable="false"
                    title="Nenhuma consolidação para esta data."
                    description="Use &quot;Consolidar o dia&quot; — a consolidação lê a chamada já lançada no diário."></el-alert>
            </div>

            <!-- ==================== PERÍODO ==================== -->
            <div v-else>
                <el-form label-position="top" @submit.native.prevent>
                    <el-row :gutter="10" class="u-mb-15">
                        <el-col :xs="12" :sm="5">
                            <el-form-item label="De" class="u-mb-0">
                                <el-date-picker v-model="dataInicial" type="date" format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="5">
                            <el-form-item label="Até" class="u-mb-0">
                                <el-date-picker v-model="dataFinal" type="date" format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="14" class="u-text-right u-mt-25">
                            <el-button size="small" icon="el-icon-search" @click="carregarPeriodo">CONSULTAR</el-button>
                        </el-col>
                    </el-row>
                </el-form>

                <div v-if="periodo">
                    <el-row :gutter="10" class="u-mb-20">
                        <el-col :xs="12" :sm="6"><div class="kpi"><span class="n">{{ periodo.dias }}</span><span class="r">Dias consolidados</span></div></el-col>
                        <el-col :xs="12" :sm="6"><div class="kpi"><span class="n">{{ periodo.media_presentes }}</span><span class="r">Média de presentes/dia</span></div></el-col>
                        <el-col :xs="12" :sm="6"><div class="kpi kpi-refeicao"><span class="n">{{ periodo.total_refeicoes_previstas }}</span><span class="r">Refeições previstas</span></div></el-col>
                        <el-col :xs="12" :sm="6">
                            <div class="kpi">
                                <span class="n">{{ periodo.total_refeicoes_servidas !== null ? periodo.total_refeicoes_servidas : '—' }}</span>
                                <span class="r">Refeições servidas</span>
                            </div>
                        </el-col>
                    </el-row>

                    <div v-if="periodo.serie.length" class="u-mb-20">
                        <bar-chart :chart-data="dadosGrafico" :height="280"></bar-chart>
                    </div>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 130px;">Data</th>
                                    <th style="width: 120px;" class="u-text-center">Matriculados</th>
                                    <th style="width: 110px;" class="u-text-center">Presentes</th>
                                    <th style="width: 90px;" class="u-text-center">%</th>
                                    <th style="width: 130px;" class="u-text-center">Previstas</th>
                                    <th style="width: 130px;" class="u-text-center">Servidas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="d in periodo.serie" :key="d.data">
                                    <td>{{ dataBr(d.data) }}</td>
                                    <td class="u-text-center">{{ d.matriculados }}</td>
                                    <td class="u-text-center">{{ d.presentes }}</td>
                                    <td class="u-text-center">{{ d.percentual_presenca !== null ? d.percentual_presenca + '%' : '—' }}</td>
                                    <td class="u-text-center">{{ d.refeicoes_previstas }}</td>
                                    <td class="u-text-center">{{ d.refeicoes_servidas !== null ? d.refeicoes_servidas : '—' }}</td>
                                </tr>
                                <tr v-if="periodo.serie.length === 0"><td colspan="6" class="u-text-center">Nenhum dia consolidado neste intervalo.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </c-panel>
    </div>
</template>
<script>
import BarChart from '@/chart/BarChart.js'

/** BLOCO I — item 132: presença diária para a merenda. */
export default {
    components: { BarChart },
    data: () => ({
        aba: 'diario', instituicaoId: null, instituicoes: [],
        data: '', dataInicial: '', dataFinal: '',
        diario: null, periodo: null, servidas: {}
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        dadosGrafico () {
            if (!this.periodo) return { labels: [], datasets: [] }

            return {
                labels: this.periodo.serie.map(d => this.dataBr(d.data).substring(0, 5)),
                datasets: [
                    { label: 'Presentes', backgroundColor: '#67C23A', data: this.periodo.serie.map(d => d.presentes) },
                    { label: 'Refeições previstas', backgroundColor: '#409EFF', data: this.periodo.serie.map(d => d.refeicoes_previstas) }
                ]
            }
        }
    },
    mounted () {
        const hoje = new Date().toISOString().substring(0, 10)
        this.data = hoje
        this.dataFinal = hoje
        this.dataInicial = new Date(Date.now() - 29 * 86400000).toISOString().substring(0, 10)

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id }

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (Array.isArray(r.data) && r.data.length) this.instituicoes = r.data })
         .catch(() => {}).then(() => this.recarregar())
    },
    methods: {
        recarregar () {
            if (this.aba === 'diario') this.carregarDiario()
            else this.carregarPeriodo()
        },
        carregarDiario () {
            this.diario = null
            if (!this.instituicaoId || !this.data) return

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/presenca-merenda/relatorioDiario`,
                { instituicao_id: this.instituicaoId, data: this.data }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.diario = r.data
                this.servidas = {}
                ;(r.data.por_turno || []).forEach(t => {
                    this.$set(this.servidas, t.id, t.qtd_refeicoes_servidas)
                })
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregarPeriodo () {
            this.periodo = null
            if (!this.instituicaoId || !this.dataInicial || !this.dataFinal) return

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/presenca-merenda/relatorioPeriodo`,
                { instituicao_id: this.instituicaoId, data_inicial: this.dataInicial, data_final: this.dataFinal },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.periodo = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        consolidar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/presenca-merenda/consolidar`,
                { instituicao_id: this.instituicaoId, data: this.data }, this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', {
                    msg: `${r.data.turmas_consolidadas} turma(s) · ${r.data.total_refeicoes_previstas} refeições previstas.`,
                    type: 'success'
                })
                this.carregarDiario()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        informarServidas (t) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/presenca-merenda/informarServidas/${t.id}`,
                { qtd_refeicoes_servidas: this.servidas[t.id] }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.carregarDiario()
            }).catch(e => this.$store.commit('throwException', e))
        },
        imprimir () {
            window.eventBus.$emit('print', {
                url: '/api/presenca-merenda/imprimirDiario',
                param: { instituicao_id: this.instituicaoId, data: this.data }
            })
        },
        rotuloTurno (t) {
            return { 0: 'Matutino', 1: 'Vespertino', 2: 'Noturno', 4: 'Integral' }[t] || t
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.kpi .n { display: block; font-size: 22px; font-weight: bold; }
.kpi .r { display: block; font-size: 11px; color: #606266; }
.kpi-refeicao { border-left: 4px solid #409eff; }
</style>
